import React, { useEffect } from 'react'
import NavBar from '../Common/Navbar'
import aboutImg from "../../assets/Images/ab-img.png";
import AboutUs from '../Home/AboutUs';
import Cards from '../Home/Cards';

import feature1 from '../../assets/Images/feature1.png';
import feature2 from '../../assets/Images/feature2.png';
import feature3 from '../../assets/Images/feature3.png';
import feature4 from '../../assets/Images/feature4.png';
import Experience from '../Home/Experience';
import ExperienceContent from '../Home/ExperienceContent';
import Clients from '../Home/Clients';
import Work from '../Home/Work';
import OurTeam from '../Home/OurTeam';
import Faq from '../Home/Faq';
import Footer from '../Common/Footer';
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '..//Home/TopButton';


function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center">
                    <h2>About Us</h2>
                </div>
            </div>
            <div className="about-img">
                <div className="container d-flex justify-content-center">
                    <img src={aboutImg} alt="aboutImg" />
                </div>
                <div className="about-pd">
                    <AboutUs />
                </div>
            </div>
            <section className='cards position-relative' style={{padding: '15px 0 90px 0'}}>
                <div className="container">
                    <div className="d-flex gap-3 align-items-center">
                        <hr className='hr4'/>
                        <p className='para1'>Creative Solution</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 mt-0">
                            <div className='card-content'>
                                <figure>
                                    <img src={feature1} alt="feature1.img" />
                                </figure>
                                <h3>Customized Solutions</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-0">
                            <div className='card-content'>
                                <figure>
                                    <img src={feature2} alt="feature1.img" />
                                </figure>
                                <h3>Customized Solutions</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt mt-0">
                            <div className='card-content'>
                                <figure>
                                    <img src={feature3} alt="feature1.img" />
                                </figure>
                                <h3>Customized Solutions</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt mt-0">
                            <div className='card-content'>
                                <figure>
                                    <img src={feature4} alt="feature1.img" />
                                </figure>
                                <h3>Customized Solutions</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='experience'>
                <Experience />
                <ExperienceContent />
            </div>
            <Clients />
            <Work />
            <div className='team'>
                <OurTeam />
            </div>
            <Faq />
            <div className='footer'>
                <Footer />
                <FooterMenu />
                <Copyright />
            </div>
            <TopButton />
        </>
    )
}

export default About
